export const RightBlueArrowIcon = ({ hover }: any) => (
  <svg
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className={`${hover}`}
      d="M9.4814 0.814819L14.6666 6M14.6666 6L9.4814 11.1852M14.6666 6L1.33325 6"
      stroke="#3460DC"
      strokeWidth="1.48148"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);
export const LeftBlueArrowIcon = ({ hover }: any) => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className={`${hover}`}
      d="M6.44444 12.4444L1 6.99999M1 6.99999L6.44444 1.55554M1 6.99999L15 6.99999"
      stroke="#3460DC"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
